import { z } from "zod";

import { TaskSort } from "@/lib/enums/assist/task-sort";
import { TaskTab } from "@/lib/enums/assist/task-tab";
import { TaskPriority } from "@/lib/enums/nuntius/task/task-priority";
import { getLastDaysRange } from "@/lib/helpers/date";

const DEFAULT_PERIOD_DAYS = 30;

const getDefaultFrom = (): string => getLastDaysRange(DEFAULT_PERIOD_DAYS).from;

const getDefaultTo = (): string => getLastDaysRange(DEFAULT_PERIOD_DAYS).to;

export const tasksPageSearchSchema = z.object({
  action: z.string().optional().catch(undefined),
  tab: z.enum(TaskTab).default(TaskTab.Todo).catch(TaskTab.Todo),
  q: z.string().default("").catch(""),
  priority: z.array(z.enum(TaskPriority)).default([]).catch([]),
  from: z.iso.date().default(getDefaultFrom).catch(getDefaultFrom),
  to: z.iso.date().default(getDefaultTo).catch(getDefaultTo),
  sort: z.enum(TaskSort).default(TaskSort.Urgency).catch(TaskSort.Urgency),
});

export type TasksPageSearchSchema = z.infer<typeof tasksPageSearchSchema>;

export const getTasksPageSearchDefaults = (): TasksPageSearchSchema =>
  tasksPageSearchSchema.parse({});
